





















import { Component, Prop, Vue } from "vue-property-decorator";
import { intervensiNyeri, IntervensiNyeri } from "@/utils/nyeriIntervensi";

@Component
export default class IndikatorNyeri extends Vue {
  @Prop({ default: null }) readonly metode!: string | null;
  @Prop({ default: null }) readonly skala!: number | null;

  get intervensi(): IntervensiNyeri | null {
    return intervensiNyeri(this.metode, this.skala);
  }
}
